module.exports = __webpack_public_path__ + "static/media/kasumin.c6e5cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/xanthomonas_pimiento/curativa/kasumin.png
// module id = 1447
// module chunks = 3